var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "v-product" }, [
    _c("div", { staticClass: "v-product__image_wrap" }, [
      _c("img", {
        staticClass: "v-product__image",
        attrs: {
          width: "600px",
          sizes: "(max-width: 64em) 400px, 600px",
          src: `${
            _vm.image ||
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAApJREFUeNpjZgAAAAgABPsKmp8AAAAASUVORK5CYII="
          }`,
        },
      }),
    ]),
    _c("div", { staticClass: "v-product__wrap_content" }, [
      _c(
        "div",
        {
          staticClass: "v-product__content",
          class: { "v-product__content_no_categ": !_vm.careTag },
        },
        [
          _vm.careTag
            ? _c("p", { staticClass: "v-product__category" }, [
                _vm._v(" " + _vm._s(_vm.$t(`care_tag.${_vm.careTag}`)) + " "),
              ])
            : _vm._e(),
          _c("p", { staticClass: "v-product__title" }, [
            _vm._v(
              " " + _vm._s(_vm._f("truncate")(_vm.title, false, 50)) + " "
            ),
          ]),
          _c(
            "p",
            {
              staticClass: "v-product__description",
              class: { "v-product__description--unfolded": _vm.folded },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm._f("truncate")(_vm.description, _vm.folded, 68)) +
                  " "
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "v-product__content_cta" },
        [
          _c("span", { staticClass: "v-product__price" }, [
            _vm._v(_vm._s(_vm.formattedPrice)),
          ]),
          _c(
            "v-button",
            {
              staticClass: "v-product__button",
              attrs: { forceHover: _vm.isSelected, isResult: true },
              on: {
                click: function ($event) {
                  return _vm.$emit("select")
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.isSelected
                      ? _vm.$t("result.unselect")
                      : _vm.$t("result.select")
                  ) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }